// removed by extract-text-webpack-plugin
module.exports = {"benefitsContainer":"benefitsContainer__2SaOw","headerText":"headerText__2Iei7","text":"text__KRrVH","subHeaderText":"subHeaderText__1WzHR","lenderIcon":"lenderIcon__2qE6F","benefitsDetails":"benefitsDetails__1OhRc"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/overlayNonApproved/benefitsSection/style.css
// module id = fS00
// module chunks = 323 331